(function() {
  angular.module('registration')
  .controller('createUserController', ['$scope','$log','User','$state','registrationUserService', 'asyncYamlLoader','localStorageService','$translate', '$rootScope', 
  function($scope, $log, User,$state,registrationUserService, asyncYamlLoader, localStorageService, $translate, $rootScope) {
    var vm = this;
    vm.reset = reset;
    vm.submit = submit;
    vm.previous = previous;
    vm.model = registrationUserService.createUserModel();
    vm.registrationModel = registrationUserService.registrationModel();
    vm.model.password=undefined;
    vm.terms = "";
    vm.applicationName = $rootScope.applicationName;
    if(!registrationUserService.registrationModel().id) {
      if(localStorageService.get("registrationModel")) {
        registrationUserService.registrationModel(localStorageService.get("registrationModel"));
        vm.registrationModel = registrationUserService.registrationModel();
      }
    }

    if(registrationUserService.registrationModel().userType == "admin") {
      $translate('content.registration.restrictedTerms').then((result) => {
        var restrictedTerms = result;
        $translate('content.registration.termsConditions', {restrictedTerms: restrictedTerms}).then((result) => {
          vm.terms = result;
        });
      });
    } else {
      $translate('content.registration.termsConditions', {restrictedTerms:""}).then((result) => {
        vm.terms = result;
      });
    }

    if (!registrationUserService.registrationModel().taxIds && !angular.debug && !registrationUserService.registrationModel().id) {
      $state.go('registration.nonDso');
    }

    if(registrationUserService.registrationModel().id) {
      localStorageService.set("registrationModel", registrationUserService.registrationModel(), "sessionStorage");
    }

    if (vm.model.userSaved) {
      $state.go('confirmation');
    }
    
    asyncYamlLoader().then(function(data) {
      if (!vm.securityQuestions) {
    	vm.securityQuestions = [];
      }
      Array.prototype.push.apply(vm.securityQuestions, data.content.registration.securityQuestions);
    });

    $scope.$watch('errorControl', function() {
      $scope.errorControl && $scope.errorControl.showErrors('uniqueUserId');
    });

    function previous(){
      if(!registrationUserService.registrationModel().id) {
        $state.go('registration.nonDso');
      } else {
        $state.go('registerDso', {id: registrationUserService.registrationModel().id, guid:registrationUserService.registrationModel().emailVerificationGuid,  type:registrationUserService.registrationModel().userType});
      }

    }

    function reset(){
      document.getElementById('createUserForm').reset();	
      vm.model = registrationUserService.createUserModel({});
      $scope.errorControl.showErrors('uniqueUserId');
    }

    function submit(){
      $scope.errorControl.showErrors();
      if ($scope.createUserForm.$valid) {
        vm.saving = true;
        User.save(registrationUserService.userProjection(), function(){
          vm.model.userSaved = true;
          registrationUserService.createUserModel(vm.model);
          localStorageService.remove("registrationModel");
          if(registrationUserService.registrationModel().id) {
            $state.go('root',{allParams : {
              showConfirmationMessage: "Your Registration is complete."}
              });
          } else {
            $state.go('confirmation');
          }
        },() => {
          registrationUserService.createUserModel(vm.model);
          vm.saving = false;
        });
      }
    }

  }]);
})();
